import { render, staticRenderFns } from "./DeliveriesFormSubmit.vue?vue&type=template&id=87c932dc&scoped=true&"
import script from "./DeliveriesFormSubmit.vue?vue&type=script&lang=js&"
export * from "./DeliveriesFormSubmit.vue?vue&type=script&lang=js&"
import style0 from "./DeliveriesFormSubmit.vue?vue&type=style&index=0&id=87c932dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c932dc",
  null
  
)

export default component.exports